import {Component, EventEmitter, Injectable, Input, Output} from '@angular/core';
import 'firebase/firestore';
import {Campus} from '../../model/Campus';

export interface DeleteCampusPayload {
  campus: Campus;
}

@Component({
  selector: 'app-edit-campus-delete',
  templateUrl: 'edit-campus-delete.component.html',
  styleUrls: ['edit-campus-delete.component.css'],
})

@Injectable()
export class EditCampusDeleteComponent {
  // View
  @Input() public campus: Campus;
  @Output() public deleteCampus = new EventEmitter<DeleteCampusPayload>();

  public deleteCampusClicked(): void {
    this.deleteCampus.emit({
      campus: this.campus,
    });
  }
}
